import { render, staticRenderFns } from "./NewsLandPlan.vue?vue&type=template&id=c1bd604e&"
import script from "./NewsLandPlan.vue?vue&type=script&lang=js&"
export * from "./NewsLandPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports